module.exports = __webpack_public_path__ + "assets/img/2539f14049a88c6373c77eae9d697ae6.png";